import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import imageCompression from "browser-image-compression";
import { RouteComponentProps, useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useRef, useCallback } from "react";
import moment from "moment";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import {
  createAd,
  getAdDetailsById,
  updateAd,
} from "../../redux/action-creators/adAction";
import { toast } from "../../utils/toastsMessage";
import {
  ImgTypeArray,
  locationPrediction,
  RoutingLinks,
} from "../../utils/constants";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { UserCommonStyles } from "../../styles/CommonStyles";
import "react-calendar/dist/Calendar.css";
import SocialIconSection from "../../components/sidebars/SocialIconSection";
import SettingBudget from "./SettingBudget_OnDailyBasis";
import EditAudience from "./EditAudience";
import EstimationResultAndPaymentDetail from "./EstimationResultAndPaymentDetail";
import CreateAdStep1 from "./CreateAdStep1";
import { uploadVideo } from "../../utils/fileUpload";
import {
  otherText,
  utcHoursDifference,
  calculateDateDifferences,
} from "../../utils/helper";

const postImagesBucketName = process.env.REACT_APP_BUCKET_NAME;

/**
 * @method to get random string
 * @param length
 * @returns
 */
const getRandomString = (length: number) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const AdCenter = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const id = Number(useParams<{ id: string }>().id);
  const userId = localStorage.getItem("userId");
  const currentDate = utcHoursDifference(new Date());
  const [loader, setLoader] = useState<boolean>(false);
  const [formHandler, setFormHandler] = useState<any>({
    isShowStep1: false,
    isShowStep2: false,
    isShowStep3: false,
    isShowStep4: false,
  });
  const [adData, setAdData] = useState<any[]>([]);

  // Step 1 States
  const [files, setFile] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [locationPredictions, setLocationPredictions] = useState({
    predictions: locationPrediction.predictions,
    location: locationPrediction.location,
    latitude: locationPrediction.latitude,
    longitude: locationPrediction.longitude,
  });
  const [adStartDate, setAdStartDate] = useState<any>({
    previous: "",
    current: "",
  });
  const [adEndDate, setAdEndDate] = useState<any>({
    previous: "",
    current: "",
  });

  const [adCenterStep1Data, setAdCenterStep1DAta] = useState({
    company_name: "",
    company_website_url: "",
    email: "",
    location: "",
    phone_number: "",
    reason: "",
    region: "",
  });
  const [isRunningAd, setIsRunningAd] = useState<any>({
    isRunning: false,
    consumeDays: 0,
    remainigDays: 0,
  });

  // Step 2 States
  const [budgetValue, setBudgetValue] = React.useState<string>("Daily");
  const [budgetPerDay, setBudgetPerDay] = useState<any>({
    previous: 0,
    current: 0,
  });
  const [days, setDays] = React.useState<any>({
    previous: 0,
    current: 0,
  });
  const [views, setViews] = React.useState<any>({
    previous: 0,
    current: 0,
  });
  const [clicks, setClicks] = React.useState<any>({
    previous: 0,
    current: 0,
  });
  const [paidOrUnpaidAmount, setPaidOrUnpaidAmount] = useState<any>({
    paidAmount: 0,
    unpaidAmount: 0,
    dividedAmountPerDay: 0,
  });
  const [totalAmount, setTotalAmount] = useState<any>({
    previous: 0,
    current: 0,
  });

  // Step3 States
  const [gender, setGender] = useState<string>("");
  const [minAndMaxAgeSlider, setMinAndMaxAgeSlider] = useState<number[]>([
    0, 0,
  ]);
  const [locationArray, setLocationArray] = useState<any>([]);
  const [interestArray, setInterestArray] = useState<any>([]);

  const formatLocationTags_And_TargetInterestTagsData = (
    location_arr: any,
    target_interest_arr: any
  ) => {
    if (location_arr.length > 0) {
      const temp = [];
      location_arr.forEach((obj: any) => {
        const newObject = {
          location: obj?.address,
          latitude: obj?.latitude,
          longitude: obj?.longitude,
        };
        temp.push(newObject);
      });
      setLocationArray(temp);
    }
    if (target_interest_arr.length > 0) {
      const temp2 = [];
      target_interest_arr.forEach((obj: any) => {
        const newObject2 = {
          tags: obj?.tags,
        };
        temp2.push(newObject2);
      });
      setInterestArray(temp2);
    }
  };

  const getadData = useCallback(
    async (id: number) => {
      setLoader(true);
      let result: any = await dispatch(getAdDetailsById(id));
      if (result && result?.isFound && result?.status === 200) {
        console.log("result :>> ", result);
        if (result?.adCenterData[0].image !== "" || null || undefined) {
          let data = result?.adCenterData[0]?.image;
          data = JSON.parse(data);
          setUploadedFiles(data);
        } else {
          let data = result?.adCenterData[0]?.video;
          data = JSON.parse(data);
          setUploadedFiles(data);
        }
        setAdData(result?.adCenterData);
        const startDate = utcHoursDifference(
          result?.adCenterData[0]?.start_date
        );
        const endDate = utcHoursDifference(
          result?.packagePurchaseHistoryData[0]?.end_date
        );
        const totalDays = result?.packagePurchaseHistoryData[0]?.days;
        const consumedDays = calculateDateDifferences(startDate, currentDate);
        const remainingDays = totalDays - consumedDays;
        const arr = [];
        arr.push(
          result?.adCenterAudiencesData[0]?.from_age,
          result?.adCenterAudiencesData[0]?.to_age
        );

        setAdStartDate({ previous: startDate, current: startDate });
        setAdEndDate({ previous: endDate, current: endDate });
        setIsRunningAd({
          isRunning: consumedDays >= 0 && remainingDays > 0,
          consumeDays: consumedDays > 0 ? consumedDays : 0,
          remainingDays: consumedDays > 0 ? remainingDays : totalDays,
        });
        setLocationPredictions((prevState) => ({
          ...prevState,
          location: result?.adCenterData[0].address,
          latitude: result?.adCenterData[0].latitude,
          longitude: result?.adCenterData[0].longitude,
        }));
        setAdCenterStep1DAta((prevState) => ({
          ...prevState,
          company_name: result?.adCenterData[0].company_name,
          company_website_url: result?.adCenterData[0].company_website_url,
          email: result?.adCenterData[0].email,
          phone_number: result?.adCenterData[0].phone_number,
          region: result?.adCenterData[0].region,
          reason: result?.adCenterData[0].Reason,
        }));
        setBudgetValue("Daily"); // set default value this value is optional and not valueable.
        setBudgetPerDay({
          previous: result?.packagePurchaseHistoryData[0]?.package_budget,
          current: result?.packagePurchaseHistoryData[0]?.package_budget,
        });
        setPaidOrUnpaidAmount({
          paidAmount: result?.packagePurchaseHistoryData[0]?.amount || 0,
          unpaidAmount: 0,
          dividedAmountPerDay: 0
        });
        setTotalAmount({
          previous: result?.packagePurchaseHistoryData[0]?.amount || 0,
          current: result?.packagePurchaseHistoryData[0]?.amount || 0,
        });
        setDays({
          previous: result?.packagePurchaseHistoryData[0]?.days || 0,
          current: result?.packagePurchaseHistoryData[0]?.days || 0,
        });
        setViews({
          previous: result?.packagePurchaseHistoryData[0]?.views || 0,
          current: result?.packagePurchaseHistoryData[0]?.views || 0,
        });
        setClicks({
          previous: result?.packagePurchaseHistoryData[0]?.clicks || 0,
          current: result?.packagePurchaseHistoryData[0]?.clicks || 0,
        });
        setGender(result?.adCenterAudiencesData[0]?.target_gender);
        setMinAndMaxAgeSlider(arr);
        formatLocationTags_And_TargetInterestTagsData(
          result?.adTargetLocationsData,
          []
        );
        formatLocationTags_And_TargetInterestTagsData(
          [],
          result?.adTargetTagsData
        );
      }
      setLoader(false);
    },
    [dispatch]
  );

  useEffect(() => {
    if (location.pathname === "/edit-ad/" + id) {
      setFormHandler({
        isShowStep1: true,
        isShowStep2: false,
        isShowStep3: false,
        isShowStep4: false,
      });
      getadData(id);
    } else if (location.pathname === "/promote-ad/" + id) {
      setFormHandler({
        isShowStep1: false,
        isShowStep2: true,
        isShowStep3: false,
        isShowStep4: false,
      });
      getadData(id);
    } else {
      setFormHandler({
        isShowStep1: true,
        isShowStep2: false,
        isShowStep3: false,
        isShowStep4: false,
      });
    }
  }, [getadData, id, location.pathname]);

  /**
   * To handle selcted files
   * @param file
   */
  const handleChange = async (file) => {
    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        if (file[i].type !== undefined) {
          const imgType = file[i].type.split("/");
          const MimeTypeArray = ImgTypeArray;
          if (imgType[1] !== undefined) {
            if (MimeTypeArray.includes(imgType[1])) {
              if (file && file[i]) {
                const img = file[i];
                try {
                  const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 720,
                    useWebWorker: true,
                  };
                  const compressImg = await imageCompression(img, options);
                  // readFile(compressImg);
                } catch (e) {
                  console.error("Error while compressing image : ", e);
                }
              }
            }
          }
        }
      }
    }
  };

  /**
   * To submit data
   * @param data
   * @returns
   */
  // Previos Create Ad code
  // const onSubmit = async (data: IAdList) => {
  //   setDisable(true);
  //   if (files.length === 0) {
  //     setimageError(translation("img_req"));
  //     setDisable(false);
  //   }

  //   if (locationPredictions.latitude === 0) {
  //     setlocationerr(true);
  //     setDisable(false);
  //   }

  //   if (files.length > 0 && locationPredictions.latitude !== 0) {
  //     if (!id) {
  //       if (validateDateOfBirth()) {
  //         createAd({
  //           data,
  //           adStartDate,
  //           locationPredictions,
  //           files,
  //           userId,
  //         }).then((response) => {
  //           if (response.data.isRegistered) {
  //             props?.history?.push({
  //               pathname: "/adpackages",
  //               state: {
  //                 adDetails: data,
  //                 adid: response?.data?.id,
  //               },
  //             });
  //           } else {
  //             return toast.error(translation(response.data.data.message));
  //           }
  //         });
  //       }
  //     } else {
  //       const adDate = moment(adStartDate).format("yyyy-MM-DD");
  //       updateAd(
  //         {
  //           data,
  //           adStartDate: adDate,
  //           locationPredictions,
  //           files,
  //           userId,
  //         },
  //         id
  //       ).then((response) => {
  //         if (response.data.isRegistered) {
  //           props?.history?.push({
  //             pathname: "/adlist",
  //             state: data,
  //           });
  //           return toast.success(translation("update_Ad"));
  //         } else {
  //           return toast.error(translation(response.data.data.message));
  //         }
  //       });
  //     }
  //   }
  // };

  const onSubmitAdData = async (
    stripeResponse: any,
    error: any,
    setIsDisabled: any
  ) => {
    const {
      company_name,
      company_website_url,
      email,
      location,
      phone_number,
      reason,
      region,
    } = adCenterStep1Data || {};
    const fileType = files.length ? files[0].split("/")[0].split(":")[1] : "";
    let file: any;
    if (!id) {
      if (files.length > 0 && fileType === "image") {
        file = files;
      } else if (files.length > 0 && fileType === "video") {
        file = await uploadVideo(
          files[0],
          postImagesBucketName,
          `${userId}/adVideo/${getRandomString(6)}`
        );
      }
    } else {
      if (
        uploadedFiles.length === 0 &&
        files.length > 0 &&
        fileType === "image"
      ) {
        file = files;
      } else if (
        uploadedFiles.length === 0 &&
        files.length > 0 &&
        fileType === "video"
      ) {
        file = await uploadVideo(
          files[0],
          postImagesBucketName,
          `${userId}/adVideo/${getRandomString(6)}`
        );
      } else {
        file = [];
      }
    }

    const completeAdData = {
      userId: Number(userId),
      fileType,
      files: file,
      locationPredictions: {
        location: locationPredictions?.location,
        latitude: locationPredictions?.latitude,
        longitude: locationPredictions?.longitude,
      },
      adStartDate: moment(adStartDate?.current).format("yyyy-MM-DD"),
      adEndDate: moment(adEndDate.current).format("yyyy-MM-DD"),
      packageAmount:
        !id && paidOrUnpaidAmount?.unpaidAmount > 0
          ? paidOrUnpaidAmount?.unpaidAmount
          : totalAmount?.previous,
      packageBudget:
        id ? Number(
              (
                paidOrUnpaidAmount?.dividedAmountPerDay +
                budgetPerDay?.current
              )?.toFixed(2)
            )
          : Number(budgetPerDay?.current?.toFixed(2)),
      // packageViewsReach: Number(views?.current?.toFixed(0)),
      packageViewsReach: Number((views?.current * days?.current)?.toFixed(0)),
      // packageClicksReach: Number(clicks?.current?.toFixed(0)),
      packageClicksReach: Number((clicks?.current * days?.current)?.toFixed(0)),
      days: days?.current,
      audienceData: {
        target_gender: gender,
        from_age: minAndMaxAgeSlider[0],
        to_age: minAndMaxAgeSlider[1],
      },
      tagLocations: locationArray,
      tagTargets: interestArray,
      data: {
        company_name: company_name,
        company_website_url: company_website_url,
        email: email,
        phone_number: phone_number,
        region: region,
        reason: reason,
        start_date: moment(adStartDate?.current).format("yyyy-MM-DD"),
      },
      payment_id: stripeResponse?.id ? stripeResponse?.id : null,
      newPackageAmount:
        id && paidOrUnpaidAmount?.unpaidAmount > 0
          ? paidOrUnpaidAmount?.unpaidAmount
          : null,
      // newPackageAmount:
      //   id && days?.previous && days?.current > days?.previous
      //     ? days?.current * budgetPerDay?.current -
      //       days?.previous * budgetPerDay?.previous
      //     : // ? budgetPerDay?.previous * (days?.current - days?.previous)
      //       null,
    };
    console.log("completeAdData :>> ", completeAdData);
    if (!id) {
      const response: any = await dispatch(createAd(completeAdData));
      if (response && response?.isSuccess) {
        toast.success(response?.message);
        setIsDisabled(false);
        props.history.push(RoutingLinks.adlist);
      } else {
        setIsDisabled(false);
        return toast.error("Something went wrong. Please try again later.");
      }
    } else {
      const updateAdResponse: any = await dispatch(
        updateAd(completeAdData, id)
      );
      if (updateAdResponse && updateAdResponse?.isSuccess) {
        toast.success(updateAdResponse?.message);
        setIsDisabled(false);
        props.history.push(RoutingLinks.adlist);
      } else {
        setIsDisabled(false);
        return toast.error("Something went wrong. Please try again later.");
      }
    }
  };

  const cancelProduct = () => {
    setUploadedFiles([]);
    setFile([]);
    setAdStartDate({ previous: "", current: "" });
    setAdCenterStep1DAta((prev) => ({
      ...prev,
      company_name: "",
      company_website_url: "",
      email: "",
      location: "",
      phone_number: "",
      reason: "",
      region: "",
    }));
    setLocationPredictions({
      predictions: locationPrediction.predictions,
      location: locationPrediction.location,
      latitude: locationPrediction.latitude,
      longitude: locationPrediction.longitude,
    });
    setBudgetPerDay({ previous: 0, current: 0 });
    setDays({ previous: 0, current: 0 });
    setBudgetValue("");
    setGender("");
    setMinAndMaxAgeSlider([0, 0]);
    setLocationArray([]);
    setInterestArray([]);
    props.history.push(RoutingLinks.adlist);
  };

  return (
    <>
      {formHandler.isShowStep1 ? (
        <Box className={`${commonStyle.windowColor}`}>
          <Grid container>
            <Grid item md={3}>
              <LeftSidebar />
              {/* <SocialIconSection /> */}
            </Grid>
            <Grid item md={9}>
              {loader ? (
                otherText("Loading...")
              ) : (
                <Box className={`${commonStyle.p20} ${commonStyle.mt20}`}>
                  <Typography
                    variant="h6"
                    className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
                  >
                    {id ? "Edit Ad" : "Ad List"}
                  </Typography>
                  {/* ////////////////////////////////////// */}
                  {id &&
                  adData.length > 0 &&
                  adCenterStep1Data.company_name !== "" &&
                  adCenterStep1Data.company_website_url !== "" &&
                  adCenterStep1Data.email !== "" &&
                  adCenterStep1Data.reason !== "" &&
                  adCenterStep1Data.region !== "" ? (
                    <CreateAdStep1
                      isEdit={true}
                      setFormHandler={setFormHandler}
                      adCenterStep1Data={adCenterStep1Data}
                      setAdCenterStep1DAta={setAdCenterStep1DAta}
                      adStartDate={adStartDate}
                      setAdStartDate={setAdStartDate}
                      adEndDate={adEndDate}
                      setAdEndDate={setAdEndDate}
                      locationPredictions={locationPredictions}
                      setLocationPredictions={setLocationPredictions}
                      files={files}
                      setFile={setFile}
                      uploadedFiles={uploadedFiles}
                      days={days}
                      setDays={setDays}
                      isRunningAd={isRunningAd}
                      currentDate={currentDate}
                      setUploadedFiles={setUploadedFiles}
                      cancelProduct={cancelProduct}
                    />
                  ) : (
                    !id && (
                      <CreateAdStep1
                        isEdit={false}
                        setFormHandler={setFormHandler}
                        adCenterStep1Data={adCenterStep1Data}
                        setAdCenterStep1DAta={setAdCenterStep1DAta}
                        adStartDate={adStartDate}
                        setAdStartDate={setAdStartDate}
                        adEndDate={adEndDate}
                        setAdEndDate={setAdEndDate}
                        locationPredictions={locationPredictions}
                        setLocationPredictions={setLocationPredictions}
                        files={files}
                        setFile={setFile}
                        uploadedFiles={uploadedFiles}
                        days={days}
                        setDays={setDays}
                        isRunningAd={isRunningAd}
                        currentDate={currentDate}
                        setUploadedFiles={setUploadedFiles}
                        cancelProduct={cancelProduct}
                      />
                    )
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      ) : formHandler.isShowStep2 ? (
        <SettingBudget
          isPromote={location.pathname === "/promote-ad/" + id}
          isEdit={id ? true : false}
          paidOrUnpaidAmount={paidOrUnpaidAmount}
          setPaidOrUnpaidAmount={setPaidOrUnpaidAmount}
          totalAmount={totalAmount}
          setTotalAmount={setTotalAmount}
          budgetValue={budgetValue}
          setBudgetValue={setBudgetValue}
          budgetPerDay={budgetPerDay}
          setBudgetPerDay={setBudgetPerDay}
          days={days}
          setDays={setDays}
          views={views}
          setViews={setViews}
          clicks={clicks}
          setClicks={setClicks}
          isRunningAd={isRunningAd}
          currentDate={currentDate}
          adStartDate={adStartDate}
          adEndDate={adEndDate}
          setFormHandler={setFormHandler}
        />
      ) : formHandler.isShowStep3 ? (
        <EditAudience
          gender={gender}
          setGender={setGender}
          minAndMaxAgeSlider={minAndMaxAgeSlider}
          setMinAndMaxAgeSlider={setMinAndMaxAgeSlider}
          locationArray={locationArray}
          setLocationArray={setLocationArray}
          interestArray={interestArray}
          setInterestArray={setInterestArray}
          setFormHandler={setFormHandler}
        />
      ) : formHandler.isShowStep4 ? (
        <EstimationResultAndPaymentDetail
          paidOrUnpaidAmount={paidOrUnpaidAmount}
          setPaidOrUnpaidAmount={setPaidOrUnpaidAmount}
          totalAmount={totalAmount}
          setTotalAmount={setTotalAmount}
          budgetPerDay={budgetPerDay}
          isEdit={!id ? false : true}
          isRunningAd={isRunningAd}
          days={days}
          adCenterStep1Data={adCenterStep1Data}
          onSubmitAdData={onSubmitAdData}
          setFormHandler={setFormHandler}
        />
      ) : null}
    </>
  );
};

export default AdCenter;
